(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const itemSelector = '.product__media-side-icons__item--has-label';

  const closeItem = (item) => {
    item.classList.remove('is-open');
    item.setAttribute('aria-expanded', 'false');
  };

  const syncItems = () => {
    document.querySelectorAll(itemSelector).forEach((item) => {
      closeItem(item);

      if (mobileQuery.matches) {
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
      } else {
        item.removeAttribute('role');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-expanded');
      }
    });
  };

  const toggleItem = (item) => {
    const willOpen = !item.classList.contains('is-open');
    item.closest('.product__media-side-icons').querySelectorAll(itemSelector).forEach(closeItem);
    item.classList.toggle('is-open', willOpen);
    item.setAttribute('aria-expanded', String(willOpen));
  };

  document.addEventListener('click', (event) => {
    if (!mobileQuery.matches) return;

    const item = event.target.closest(itemSelector);
    if (item) {
      toggleItem(item);
      return;
    }

    document.querySelectorAll(`${itemSelector}.is-open`).forEach(closeItem);
  });

  document.addEventListener('keydown', (event) => {
    if (!mobileQuery.matches || (event.key !== 'Enter' && event.key !== ' ')) return;

    const item = event.target.closest(itemSelector);
    if (!item) return;

    event.preventDefault();
    toggleItem(item);
  });

  syncItems();
  mobileQuery.addEventListener('change', syncItems);
  document.addEventListener('shopify:section:load', syncItems);
})();
